import { useState } from "react"
import Select from 'react-select'


export const AreaCommanDDL = () => {
    const [WardNameID, setWardNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const optionsWardName = [
        { id: 1, value: 'मुकाई चौक', label: 'मुकाई चौक' },
        { id: 2, value: 'चाफेकर चौक', label: 'चाफेकर चौक' },
    ]
    return (
        <>
            <Select
                id='WardNameID'
                isClearable={false}
                // isRtl={isRtl}
                isSearchable
                maxMenuHeight={130}
                value={{ value: WardNameID.ID, label: WardNameID.Label }}
                onChange={(e) => {
                    e ?
                        setWardNameID({ ...WardNameID, ID: e.value, Label: e.label })
                        :
                        setWardNameID({ ...WardNameID, ID: 0, Label: "Select..." })

                }}
                options={optionsWardName}
            />
        </>
    )
}